<template>
	<v-dialog v-model="dialog" persistent max-width="600" scrollable>
		<v-card v-if="terms">
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-13 cl-primary text-capitalize">{{ terms.title }}</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<div class="d-block py-4">
					{{ terms.content }}
				</div>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="3">
					<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" @click="modalHide">
						<v-icon small v-if="false">mdi-close</v-icon>
						<span>Tutup</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
		}
	},
	computed: {
	},
	props: ['terms'],
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
	}
};
</script>